module.exports = __webpack_public_path__ + "img/left-arrow.4da35bbb.svg";